import React, { useLayoutEffect, useRef } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { BenefitsContent } from '../content/BenefitsContent';

function Benefits() {
  const rowRef = useRef(null);
  const referenceCardRef = useRef(null);

  useLayoutEffect(() => {
    const row = rowRef.current;
    const referenceCard = referenceCardRef.current;
    if (!row || !referenceCard) return;

    const sync = () => {
      const cards = row.querySelectorAll('.rwm-benefits__card');
      cards.forEach((node) => {
        node.style.minHeight = '';
      });
      void referenceCard.offsetHeight;
      const height = Math.ceil(referenceCard.getBoundingClientRect().height);
      if (height < 1) return;
      cards.forEach((node) => {
        node.style.minHeight = `${height}px`;
      });
    };

    sync();

    const observer = new ResizeObserver(() => {
      sync();
    });
    observer.observe(row);

    window.addEventListener('resize', sync);

    const fonts = document.fonts;
    if (fonts?.ready) {
      fonts.ready.then(sync).catch(() => {});
    }

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', sync);
    };
  }, []);

  return (
    <div>
      <h2 className="centralized-content fw-semibold mt-5">Remote Work Benefits</h2>
      <h6 className="centralized-content mt-4">Work from anywhere. Live on your terms.</h6>
      <Row ref={rowRef} className="tw-mt-3">
        {BenefitsContent.map((benefit) => (
          <Col key={benefit.id} sm={12} md={6} lg={4} xl={3}>
            <Card
              ref={benefit.id === 1 ? referenceCardRef : undefined}
              className="rwm-benefits__card shadow my-3 p-3 rounded left-aligned-content"
            >
              <Card.Img src={benefit.image} width="32" height="32"/>
              <Card.Body>
                <Card.Title as="div">
                  <strong>{benefit.title}</strong>
                </Card.Title>

                <Card.Text as="div">
                  <div className="my-3">
                    {benefit.contentText}
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default Benefits;
